// initialisiert summernote
import scrollToAnchorTarget from './scrollToAnchorTarget';
import MultiStepForm from './lib/multiStepForm';
import './lib/jquery';
import './lib/third-party/summernote-lite.js';
import './lib/third-party/lang/summernote-de-DE.js';

const wizardElement = document.querySelector('.wizard');

if (wizardElement) {
	$(() => {
		$(document).ready(() => {
			const wizard = new MultiStepForm(wizardElement);
			scrollToAnchorTarget(wizard);
			window.addEventListener('unload', () => {
				if (wizard) {
					wizard.destroy();
				}
			});

			const toolbarOptions = [
				['style', ['bold', 'italic', 'underline', 'clear']],
				// ['fontsize', ['fontsize']],
				// ['color', ['color']],
				// ['misc', ['undo', 'redo']],
				['para', ['ul', 'ol']], //, 'paragraph'
				['insert', ['picture']],
			];

			const popoverOptions = {
				image: [
					['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
					// ['float', ['floatLeft', 'floatRight', 'floatNone']],
					['remove', ['removeMedia']],
				],
			};

			$('[data-provider="summernote"]').each(function () {
				$(this).summernote({
					lang: 'de-DE',
					toolbar: toolbarOptions,
					popover: popoverOptions,
					tooltip: false,
					disableDragAndDrop: true,
					callbacks: {
						onChange: (i) => {
							$(this).val(i);
						},
						onPaste(e) {
							const bufferText = (
								(e.originalEvent || e).clipboardData || window.clipboardData
							).getData('Text');
							e.preventDefault();
							document.execCommand('insertText', false, bufferText);
						},
						onInit: (i) => {
							$('.note-editable').on('drop', () => false);
							i.editable.html(i.note.val());
							// i.editable.focus()
						},
					},
				});
			});
		});
	});
}
